import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyNotFoundErrorPage = lazy<ComponentType<{}>>(
	() => import(/* webpackChunkName: "async-not-found-error-page" */ './NotFoundErrorPage.tsx'),
);

export const NotFoundErrorPageAsync = () => (
	<Placeholder name="async-not-found-error-page" fallback={null}>
		<LazyNotFoundErrorPage />
	</Placeholder>
);
